import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import { GamificationPartnerConfigResponse, PointsRewardsConfiguration } from './getGamificationPartnerConfig.types'

export const getGamificationPartnerConfig: QueryFn<
  ['getGamificationPartnerConfig'],
  PointsRewardsConfiguration | null
> = async client => {
  const { data, status } = await client.get<GamificationPartnerConfigResponse>('v1/partner/gamification/config', {
    validateStatus: code => [200, 403, 404].includes(code)
  })

  return (status === 200 ? data.data?.points_rewards_configuration : undefined) ?? null
}
